import { createContext, useContext, useState, ReactNode } from "react";

interface Units {
  temperature: string;
  wind_speed: string;
  precipitationRate: string;
  ceiling: string;
  visibility: string;
  pressure: string;
}

interface CustomUnitsContextType {
  customUnits: Units | null;
  setCustomUnits: (units: Units) => void;
}

const CustomUnitsContext = createContext<CustomUnitsContextType | undefined>(undefined);

export const CustomUnitsProvider = ({ children }: { children: ReactNode }) => {
  const [customUnits, setCustomUnits] = useState<Units | null>(null);

  return (
    <CustomUnitsContext.Provider value={{ customUnits, setCustomUnits }}>
      {children}
    </CustomUnitsContext.Provider>
  );
};

export const useCustomUnitsContext = () => {
  const context = useContext(CustomUnitsContext);
  if (!context) throw new Error("useCustomUnitsContext must be used within a CustomUnitsProvider");
  return context;
};